import { ReactElement } from 'react';

import { DownloadIcon, DownloadLink, IconFillColor } from '@dreryk/react-components';

type OptionsCellProps = {
   documentUrl: string;
};

export const OptionsCell = (props: OptionsCellProps): ReactElement => {
   return (
      <DownloadLink
         testId={'downloadEdm'}
         url={props.documentUrl}
         icon={<DownloadIcon fillColor={IconFillColor.PRIMARY} testId={'download'} />}
      />
   );
};
